import { FactSetWidget, type ConfigItem } from "./FactsetWidget";

type MarketDiariesProps = {
  identifiers: ReadonlyArray<string>;
};

export function MarketDiaries({ identifiers }: MarketDiariesProps) {
  const config = [
    { type: "attribute", key: "identifiers", value: identifiers },
  ] as ConfigItem[];

  return <FactSetWidget config={config} widget="market-diaries" />;
}
